const moment = require('moment-timezone');

module.exports.getDateTimeFormat = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;
    return date.getDate()  + "/" + (date.getMonth() + 1) + "/" + date.getFullYear() + " " + strTime;
}
module.exports.displayDateTimeFormat = (date) => {
    return moment.utc(date).format("DD-MM-YYYY HH:mm").valueOf();
}
module.exports.displayDateOnlyFormat = (date) => {
    return moment.utc(date).format("DD-MM-YYYY").valueOf();
}
module.exports.getCurrentDate = () => {
    var curdate = window.localStorage.getItem('serverdate');
    return curdate;
}
module.exports.getCurrentDateOnly = () => {
    var curdate = window.localStorage.getItem('serverdate');
    return moment.utc(curdate).format("YYYY-MM-DD").valueOf();
}
module.exports.DateOnlyFormat = (date) => {
    return moment.utc(date).format("MM-DD-YYYY").valueOf();
}
module.exports.getServerDate = () => {
    var curdate = window.localStorage.getItem('serverdate');
    return moment.utc(curdate).format("DD/MM/YYYY").valueOf();
}
module.exports.addDaystoCurrentDate = (noofdays) => {
  let newDate = moment(new Date()).add(noofdays, 'days').format("MM-DD-YYYY").valueOf();
  return newDate;
}
module.exports.getFutureDateOnly = (day) => {
    var curdate = window.localStorage.getItem('serverdate');
    return moment.utc(curdate).add(day, 'days').format("YYYY-MM-DD").valueOf();
}



// WEBPACK FOOTER //
// ./src/modules/shared/util/util.js